import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Card,
  PieContainer,
  Row,
  Copy,
  Spin,
  Title
} from "app/NativeComponents/common";

import {
  appRedirect,
  getAnalyticsData,
  changeAnalyticsDateOption,
  numberWithCommas
} from "app/NativeActions";
import { DateRangePicker } from "app/NativeComponents/snippets";

import DateFilters from "./DateFilters";

class MessageDashboardStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delivery_data: [],
      total_messages: 0,
      isCalendarOpen: false,
      analytics_filters: {}
    };
  }

  toggleCalendar() {
    this.setState(prevState => {
      return { isCalendarOpen: !prevState.isCalendarOpen };
    });
  }

  componentDidMount() {
    this.getAnalytics();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.start_date !== prevProps.start_date ||
      this.props.end_date !== prevProps.end_date ||
      this.props.date_option !== prevProps.date_option
    ) {
      this.getAnalytics();
    }

    if (this.props.message_delivery !== prevProps.message_delivery) {
      this.constructData();
    }
  }

  constructData() {
    if (!this.props.message_delivery) {
      this.setState({
        delivery_data: [],
        total_messages: 0
      });
    } else {
      let pie_colors = [
        "#80ffff",
        "#52e2f9",
        "#29c7e0",
        "#00abc4",
        "#0090a8",
        "#00758d",
        "#005c73",
        "#00435a",
        "#002c42"
      ];
      let delivery_data = [];
      const total_messages =
        parseInt(
          this.props.message_delivery.messages_delivered
            ? this.props.message_delivery.messages_delivered
            : 0
        ) +
        parseInt(
          this.props.message_delivery.messages_failed
            ? this.props.message_delivery.messages_failed
            : 0
        ) +
        parseInt(
          this.props.message_delivery.messages_sending
            ? this.props.message_delivery.messages_sending
            : 0
        ) +
        parseInt(
          this.props.message_delivery.messages_unconfirmed
            ? this.props.message_delivery.messages_unconfirmed
            : 0
        );

      delivery_data.push({
        name: "Delivery Success",
        value: parseInt(this.props.message_delivery.messages_delivered),
        percentage:
          (parseInt(this.props.message_delivery.messages_delivered) /
            total_messages) *
          100,

        color: pie_colors[0]
      });

      delivery_data.push({
        name: "Delivery Failed",
        value: parseInt(this.props.message_delivery.messages_failed),
        percentage:
          (parseInt(this.props.message_delivery.messages_failed) /
            total_messages) *
          100,

        color: pie_colors[1]
      });
      if (parseInt(this.props.message_delivery.messages_sending) > 0) {
        delivery_data.push({
          name: "Sending",
          value: parseInt(this.props.message_delivery.messages_sending),
          percentage:
            (parseInt(this.props.message_delivery.messages_sending) /
              total_messages) *
            100,
          color: pie_colors[2]
        });
      }

      if (parseInt(this.props.message_delivery.messages_unconfirmed) > 0) {
        delivery_data.push({
          name: "Delivery Unconfirmed",
          value: parseInt(this.props.message_delivery.messages_unconfirmed),
          percentage:
            (parseInt(this.props.message_delivery.messages_unconfirmed) /
              total_messages) *
            100,
          color: pie_colors[3]
        });
      }

      this.setState({ delivery_data, total_messages });
    }
  }

  getAnalytics() {
    this.props.getAnalyticsData({
      token: this.props.token,
      type: "message_delivery",
      start_date: this.props.start_date,
      end_date: this.props.end_date,
      date_option: this.props.date_option,
      filters: this.state.analytics_filters
    });
  }

  renderLegend() {
    if (this.state.delivery_data && this.state.delivery_data.length > 0) {
      return (
        <Wrapper style={{ padding: 10 }}>
          {this.state.delivery_data.map((item, i) => {
            return (
              <Wrapper key={i}>
                <Row>
                  <Wrapper
                    style={{
                      width: 20,
                      height: 10,
                      backgroundColor: item.color,
                      margin: 5
                    }}
                  />
                  <Copy style={{ fontSize: 12 }}>
                    {numberWithCommas(item.value)} {item.name}
                  </Copy>
                </Row>
              </Wrapper>
            );
          })}
        </Wrapper>
      );
    }
  }

  render() {
    if (this.props.message_delivery_loading) {
      return (
        <Wrapper>
          <Card style={{ alignItems: "center", justifyContent: "center" }}>
            <Wrapper
              style={{
                width: 300,
                height: 300,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Row
                style={{
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Spin size="small" />
                <Copy style={{ marginLeft: 10 }}>Loading...</Copy>
              </Row>
            </Wrapper>
          </Card>
        </Wrapper>
      );
    }
    if (this.props.message_delivery) {
      return (
        <Wrapper>
          <DateRangePicker
            {...this.props}
            isCalendarOpen={this.state.isCalendarOpen}
            toggleCalendar={this.toggleCalendar.bind(this)}
            selectDates={({ start_date, end_date }) => {
              if (start_date != null && end_date != null) {
                this.props.changeAnalyticsDateOption({
                  date_option: "custom",
                  user: this.props.user,
                  start_date: start_date,
                  end_date: end_date
                });
              }
            }}
          />
          <Card>
            <Title style={{ padding: 15 }}>Message Delivery Status</Title>
            <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
              {this.state.total_messages > 0 ? (
                <Wrapper>
                  <PieContainer
                    width={300}
                    height={300}
                    data={this.state.delivery_data}
                    fillColor={this.props.colors.active_color}
                  />
                  {this.renderLegend()}
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    width: 300,
                    height: 300,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Copy style={{ textAlign: "center" }}>
                    You did not send any messages during this time
                  </Copy>
                </Wrapper>
              )}
              <DateFilters
                {...this.props}
                toggleCalendar={this.toggleCalendar.bind(this)}
              />
            </Wrapper>
          </Card>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, settings, analytics }) => {
  const { token, user } = auth;
  const {
    device,
    platform,
    isMobile,
    dashboardMobile,
    isIphoneX,
    mobile_toggle_drawer
  } = native;
  const { colors } = settings;
  const {
    message_delivery,
    message_delivery_loading,
    start_date,
    end_date,
    date_option
  } = analytics;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    dashboardMobile,
    isIphoneX,
    colors,

    message_delivery,
    message_delivery_loading,
    start_date,
    end_date,
    date_option
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  getAnalyticsData,
  changeAnalyticsDateOption
})(MessageDashboardStats);
